module.exports = __webpack_public_path__ + "v4assets/global_agent_icon.619f5798b56df935996524e3583248a8.png";